import remote from './remote';

export function getUltimateChallenge(id) {
  return remote.get(`competition_types/${id}/ultimate_challenges/latest`, {
    embed: ['entries', 'current_user_entry'],
  });
}

export function getHallOfFame(id) {
  return remote.get(`competition_types/${id}/ultimate_champions`, {
    embed: ['entries', 'current_user_entry'],
  });
}

export function getCompetitionsList() {
  return remote.get('sports');
}
